import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=a4927f84&scoped=true&"
import script from "./HomeBanner.vue?vue&type=script&lang=js&"
export * from "./HomeBanner.vue?vue&type=script&lang=js&"
import style0 from "./HomeBanner.vue?vue&type=style&index=0&id=a4927f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4927f84",
  null
  
)

export default component.exports